/*=========================================================================================
  File Name: moduleSpaceMutations.js
  Description: Space Module Mutations
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/
import Vue from 'vue'

export default {
  CREATE_SUBMIT(state, payload) {
    state.submits.unshift(payload)
  },
  UPDATE_SUBMIT(state, payload) {
    var index = state.submits.findIndex(function(item){return item.id == payload.id})
    if (index != -1) {
      state.submits[index].update_time = payload.update_time
      state.submits[index].file_names = payload.file_names
      state.submits[index].title = payload.title
      state.submits[index].detail = payload.detail
      state.submits[index].start = payload.start
      state.submits[index].end = payload.end
      state.ActiveSubmit =  state.submits[index]
    }
  },
  UPDATE_SUBMIT_TITLE(state, payload) {
    var index = state.submits.findIndex(function(item){return item.id == payload.id})
    state.submits[index].title = payload.title
    state.submits[index].detail = payload.detail
  },
  DELETE_SUBMIT(state, payload) {
    var index = state.submits.findIndex(function(item){return item.id == payload})
    if(index != -1){
      state.submits.splice(index,1)
    }
  },
  SET_SUBMIT_SEARCH_QUERY(state, payload){
    state.submitSearchQuery = payload
  },
  SET_ACTIVE_SUBMIT(state, payload) {
    state.ActiveSubmit = payload
  },
  SET_SUBMIT_LIST(state, payload){
    if (payload){
      state.submits = payload.sort(function(a,b) {return a.update_time > b.update_time ? -1 : a.update_time > b.update_time ? 1 : 0 })
      state.ActiveSubmit = state.submits[0]
    } else {
      state.submits = []
      state.ActiveSubmit = {
          title:'공지사항 없음',
          detail:'',
          id:0
      }
    }
  },
  SET_SUBMIT_DATE_UPDATE(state, payload){
    Vue.set(state.submits[payload.index], 'state_val', payload.val)
  },
  SET_SUBMIT_MEMBER_LIST(state, payload) {
    state.submitMembers = payload
  },
  CREATE_SUBMIT_MEMBER(state, payload) {
    state.submitMembers.unshift(payload)
  },
  UPDATE_SUBMIT_MEMBER_SCORE(state, payload){
    var index = state.submitMembers.findIndex(function(item){return item.id == payload.id})
    state.submitMembers[index].score = payload.score
    state.submitMembers[index].comment = payload.comment
  },
  UPDATE_SUBMIT_MEMBER(state, payload) {
    var index = state.submitMembers.findIndex(function(item){return item.id == payload.id})
    state.submitMembers[index].title = payload.title
    state.submitMembers[index].detail = payload.detail
    state.submitMembers[index].update_time = payload.update_time
    state.submitMembers[index].file_name = payload.file_name
  },
  DELETE_SUBMIT_MEMBER(state, payload) {
    var index = state.submitMembers.findIndex(function(item){return item.id == payload})
    if(index != -1){
      state.submitMembers.splice(index,1)
    }
  },
}
